import React, { useContext } from 'react';
import styled from 'styled-components';
import { FdrProductTravelType } from '@hotelplan/supergraph-api';
import { sx2CssThemeFn } from '@hotelplan/util.theme.sxc';
import CurrentSearchContext from 'components/domain/currentSearch/CurrentSearchContext';
import SearchControlFormLayout from 'components/domain/searchControl/SearchControlFormLayout';
import FdrTravelRoomsFieldContainer from 'fdr/components/candidate/fdr-search-control/travel-rooms/fdr-travel-rooms-field-container';
import { FdrTravelTypeField } from 'fdr/components/candidate/fdr-search-control/travel-type/fdr-travel-type-field';
import { CurrentSearchFieldTypes } from 'fdr/components/candidate/fdr-search-control/use-fdr-current-search';
import { FdrCommonFormLayout } from 'fdr/components/local/fdr-common-form-layout/fdr-common-form-layout';
import { FdrSearchTravelDates } from 'fdr/components/local/fdr-search-travel-dates';
import FdrWishlistSearchControlForm from 'fdr/components/local/fdr-wishlist/fdr-wishlist-search-control-form';
import WishlistSearchControlFormCurrentSearchField from './WishlistSearchControlFormCurrentSearchField';

const SearchControlFormLayoutWrapper = styled(SearchControlFormLayout)(
  sx2CssThemeFn({
    '.container': {
      bg: 'bgLightGrey',
      textAlign: 'center',
      pt: 3,
    },
    '.travelTypes': {
      mb: 0,
    },
  })
);

const WishlistSearchControlFormActionToggler: React.FC = () => {
  const { closeSearchControl, isSearchControlShowed, showSearchControl, ref } =
    useContext(CurrentSearchContext);

  return (
    <div ref={ref}>
      {isSearchControlShowed ? (
        <FdrWishlistSearchControlForm>
          <SearchControlFormLayoutWrapper
            travelTypes={
              <FdrTravelTypeField
                withAutoSubmitOnChange
                mainTravelTypes={[
                  FdrProductTravelType.Package,
                  FdrProductTravelType.HotelOnly,
                ]}
              />
            }
          >
            <FdrCommonFormLayout
              travelDates={<FdrSearchTravelDates />}
              travelRooms={<FdrTravelRoomsFieldContainer />}
              handleCancel={closeSearchControl}
            />
          </SearchControlFormLayoutWrapper>
        </FdrWishlistSearchControlForm>
      ) : (
        <WishlistSearchControlFormCurrentSearchField
          fieldTypes={[
            CurrentSearchFieldTypes.dates,
            CurrentSearchFieldTypes.rooms,
          ]}
          handleEdit={showSearchControl}
        />
      )}
    </div>
  );
};

export default WishlistSearchControlFormActionToggler;
